module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/promotion-list-authorization/pro-list-auth-grid/pro-list-auth-grid.component.css
// module id = ./src/app/hrms/Promotions/promotion-list-authorization/pro-list-auth-grid/pro-list-auth-grid.component.css
// module chunks = main